<script>
  export let type; // iframe, webview
  export let iframeTitle = "";
  export let id = "";
  export let src;
  export let webpreferences = "nativeWindowOpen=yes, javascript=yes";
  export let useragent =
    "Mozilla/5.0 (Android 11; Mobile; LG-M255; rv:84.0) Gecko/84.0 Firefox/84.0";
  export let isOut = false;
  export let showMenu;
  export let additionalClasses = "";
  export let webTitle = false;

  import { roundWebview, roundHalfWebview } from "../js/roundWebview";
  import {
    getPlatform,
    setOpenURL,
    setOpenURLUserAgent,
    showDomainNavMenu,
  } from "../js/localInfo";
  import { openNewWindow } from "../js/openNewWindow";

  import { onMount } from "svelte";

  const platform = getPlatform();

  let webId = id === "" ? "web" : id;

  let webview = null;

  src = src.startsWith("/") || src.startsWith("http") ? src : "https://" + src;
  let currentUrl = src;

  let copied = false;

  const COPY_TIME = 3000;

  const SHAREPOINT_USERAGENT =
    "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/88.0.4324.190 Safari/537.36";

  onMount(() => {
    if (platform === "APP") {
      webview = document.querySelector("webview#" + webId);

      webview.addEventListener("did-navigate", (e) => {
        if (
          e.url.includes("sharepoint.com") &&
          useragent !== SHAREPOINT_USERAGENT
        ) {
          useragent =
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/88.0.4324.190 Safari/537.36";
          webview.setUserAgent(useragent);
          webview.loadURL(src);
        } else {
          currentUrl = e.url;
        }
      });

      webview.addEventListener("dom-ready", (e) => {
        if (webTitle) {
          document.title = "SkyLab - " + webview.getTitle();
        }
        showMenu = showDomainNavMenu(src);
      });

      webview.addEventListener("new-window", async (e) => {
        //e.preventDefault();
        openNewWindow(e.url);
        //console.log(e.url);
      });

      if (!isOut) {
        if (showMenu) {
          roundHalfWebview(id);
        } else {
          roundWebview(id);
        }
      }
    }
  });

  let goBack = () => {
    webview.goBack();
  };

  let goForward = () => {
    webview.goForward();
  };

  let refresh = () => {
    webview.reload();
  };

  let copyToClipboard = () => {
    var dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = currentUrl;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    copied = true;
    setTimeout(stopCopied, COPY_TIME);
  };

  let stopCopied = () => {
    copied = false;
  };

  let openURL = (defaultBrowser) => {
    if (defaultBrowser) {
      window.open("/openexternal/#/" + currentUrl);
    } else {
      setOpenURL(currentUrl);
      setOpenURLUserAgent(useragent);
      window.open("/urlbrowser");
    }
  };

  let shrinkMenu = () => {
    showMenu = false;
  };

  $: if (!isOut) {
    if (showMenu) {
      roundHalfWebview(id);
    } else {
      roundWebview(id);
    }
  }

  $: if (src) {
    src =
      src.startsWith("/") || src.startsWith("http") ? src : "https://" + src;
    currentUrl = src;
    console.log(currentUrl);
  }

  //$: console.log(showMenu);
</script>

<div class="webBrowserContainer">
  {#if type === "iframe"}
    <iframe id={webId} title={iframeTitle} {src} />
  {:else}
    {#if src !== "" && showMenu}
      <div class="header {isOut ? '' : 'roundedHeader'}">
        <img
          class="fadedButton"
          src="/images/navigation/back.svg"
          alt="Go Back"
          on:click={() => goBack()}
        />
        <img
          class="fadedButton"
          src="/images/navigation/forward.svg"
          alt="Go Forward"
          on:click={() => goForward()}
        />
        <img
          class="fadedButton"
          src="/images/navigation/refresh.svg"
          alt="Refresh"
          on:click={() => refresh()}
        />
        <div class="url">
          {#if copied}
            <span class="copy">URL copied to clipboard!</span>
          {:else}
            <span>{currentUrl}</span>
          {/if}
        </div>
        <img
          class="fadedButton"
          src="/images/navigation/copy.svg"
          alt="Copy To Clipboard"
          on:click={() => copyToClipboard()}
        />
        <img
          class="fadedButton"
          src="/images/navigation/shrink.svg"
          alt="Shrink Menu"
          on:click={() => shrinkMenu()}
        />
        <img
          class="fadedButton"
          src="/images/navigation/browser.svg"
          alt="Open Website"
          on:click={() => openURL(false)}
        />
        <img
          class="fadedButton"
          src="/images/navigation/out.svg"
          alt="Open in Browser"
          on:click={() => openURL(true)}
        />
      </div>
    {/if}
    <webview
      id={webId}
      class="webview {additionalClasses}"
      {src}
      enableremotemodule="true"
      {webpreferences}
      allowpopups
      {useragent}
    />
  {/if}
</div>

<style>
  div.webBrowserContainer {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  div.header {
    background-color: var(--labit-dialog-background);
    display: flex;
    padding: 7px 12px 7px 12px;
    justify-content: space-between;
  }

  div.header img {
    height: 25px;
  }

  div.roundedHeader {
    border-radius: 10px 10px 0px 0px;
  }

  div.header img:not(:last-child) {
    margin-right: 10px;
  }

  div.url {
    background-color: white;
    display: flex;
    flex-grow: 1;
    border-radius: 5px;
    align-items: center;
    margin-right: 10px;
    font-size: 13px;
    color: var(--labit-card-gray);
    padding: 0px 5px 0px 5px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  div.url span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  span.copy {
    color: green;
  }

  iframe,
  webview {
    width: 100%;
    display: flex;
    flex-grow: 1;
    border-radius: 19px;
    border-style: none;
  }
</style>
